import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { t } from 'i18next';
import { startCase } from 'lodash-es';

import {
  FlexColumn,
  OverflowAwareText,
} from '~components/Order/ordersDispatchStyledComponents';
import { JobInvoicing } from '~hooks/useJob/models';

interface TotalQuantityColumnProps {
  job: JobInvoicing;
  quantityAdornment?: React.ReactNode;
  sx?: SxProps<Theme>;
}

export default function TotalQuantityColumn({
  job,
  quantityAdornment,
  sx,
}: TotalQuantityColumnProps) {
  const ticketsCount = job.jobSummary?.loadsWithTicketsCount ?? 0;

  const sumsByUoM = (job.jobSummary?.deliveredQuantities ?? []).reduce(
    (obj, item) => {
      const uom = String(item.unitOfMeasure);
      obj[uom] = (obj[uom] ?? 0) + Number(item.delivered);
      return obj;
    },
    {} as Record<string, number>,
  );

  const [largestSumUoM, largestSumTotal] = Object.entries(sumsByUoM).sort(
    ([, aSum], [, bSum]) => bSum - aSum,
  )[0] ?? [null, 0];

  const formattedLargestSumTotal = largestSumTotal.toFixed(2);
  const unitLabel = largestSumUoM ? startCase(largestSumUoM) : '';
  const shouldShowSum = ticketsCount > 0 && largestSumTotal > 0;

  return (
    <Box sx={sx}>
      <FlexColumn>
        <Box sx={{ alignItems: 'center', display: 'flex', gap: 0.5 }}>
          <OverflowAwareText fontWeight={700}>
            {shouldShowSum ? `${formattedLargestSumTotal} ${unitLabel}` : ''}
          </OverflowAwareText>
          {quantityAdornment}
        </Box>

        <OverflowAwareText>
          {ticketsCount} {t('approvals.driver_day.tickets')}
        </OverflowAwareText>
      </FlexColumn>
    </Box>
  );
}
